import { isDevelopment, isStaging } from "~/lib/env";

export const devLog = (...args: any[]) => {
  if (isDevelopment || isStaging) {
    console.log(...args);
  }
};

export const devError = (...args: any[]) => {
  if (isDevelopment || isStaging) {
    console.error(...args);
  }
};
